"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var GeometryUnit;
(function (GeometryUnit) {
    GeometryUnit[GeometryUnit["Pixel"] = 0] = "Pixel";
    GeometryUnit[GeometryUnit["Percent"] = 1] = "Percent";
})(GeometryUnit = exports.GeometryUnit || (exports.GeometryUnit = {}));
var GeometryValue = /** @class */ (function () {
    function GeometryValue() {
    }
    Object.defineProperty(GeometryValue, "auto", {
        get: function () {
            return { value: 0, unit: GeometryUnit.Pixel, offset: 0, _auto: true };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryValue, "zero", {
        get: function () {
            return { value: 0, unit: GeometryUnit.Pixel, offset: 0 };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryValue, "fullSize", {
        get: function () {
            return { value: 100, unit: GeometryUnit.Percent, offset: 0 };
        },
        enumerable: true,
        configurable: true
    });
    GeometryValue.parse = function (def) {
        if (typeof def === "number") {
            return GeometryValue.create(def);
        }
        else if (typeof def === "string") {
            if (def.length === 0) {
                return null;
            }
            if (def.match(/^-?[\d\.]+$/)) {
                // is a number
                return GeometryValue.create(parseFloat(def));
            }
            var matches = def.match(/^(-?\d+(\.\d+)?)%( ?[+|-] ?\d+(\.\d+)?)?$/);
            if (matches === null) {
                throw new Error("Geometry value " + def + " has wrong format");
            }
            return GeometryValue.create(parseFloat(matches[1]), GeometryUnit.Percent, matches[3] ? parseFloat(matches[3]) : 0);
        }
        return null;
    };
    GeometryValue.create = function (value, unit, offset) {
        if (value === void 0) { value = 0; }
        if (unit === void 0) { unit = GeometryUnit.Pixel; }
        if (offset === void 0) { offset = 0; }
        return { value: value, unit: unit, offset: offset };
    };
    return GeometryValue;
}());
exports.GeometryValue = GeometryValue;
var GeometryDef = /** @class */ (function () {
    function GeometryDef(opt) {
        var o = typeof opt === "undefined" ? {} : opt;
        _.defaults(o, {
            x: GeometryValue.zero, y: GeometryValue.zero,
            width: GeometryValue.auto, height: GeometryValue.auto,
        });
        this.origin = { x: o.x, y: o.y };
        this.size = { width: o.width, height: o.height };
    }
    Object.defineProperty(GeometryDef.prototype, "x", {
        get: function () { return this.origin.x; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryDef.prototype, "y", {
        get: function () { return this.origin.y; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryDef.prototype, "width", {
        get: function () { return this.size.width; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryDef.prototype, "height", {
        get: function () { return this.size.height; },
        enumerable: true,
        configurable: true
    });
    return GeometryDef;
}());
exports.GeometryDef = GeometryDef;
//# sourceMappingURL=geometry.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/geometry.js
// module id = 35
// module chunks = 0 1